<template>
  <div id="wrapper">
    <Nav :message="message" />
    <DebtCalc />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import DebtCalc from '@/components/tools/DebtCalc.vue'

export default {
  name: 'debt-calc',
  props: ['message'],
  components: {
    Nav,
    DebtCalc
  }
}
</script>